// eslint-disable-next-line no-shadow
export enum FontsEnum {
	SATOSHI = 'Satoshi',
	ZODIAK = 'Zodiak',
	INTER = 'Inter',
}
